var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContratGroupe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_187_15613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8786 1.09113H15.4375C15.848 9.79586 17.74 16.9586 22.5453 21.0896C23.353 21.0619 23.9998 20.3985 23.9998 19.584V3.21231C23.9998 2.04095 23.05 1.09113 21.8786 1.09113Z",
    fill: "#38A1A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9696 2.9093H15.9367C15.0362 9.41316 15.6969 15.551 18.909 21.0909H22.4929C22.5105 21.0909 22.5279 21.0902 22.5453 21.0896V6.48502C22.5453 4.51336 20.9413 2.9093 18.9696 2.9093Z",
    fill: "#288E96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6509 1.64869C15.393 0.515906 14.2592 -0.209203 13.1098 0.0540466L1.64859 2.67703C0.506761 2.93836 -0.207426 4.0763 0.0539018 5.21812L3.63642 20.8721L15.9367 2.9093L15.6509 1.64869Z",
    fill: "#05E29A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9368 2.9093H7.21219C5.24054 2.9093 3.63647 4.51336 3.63647 6.48502V20.8721L3.73149 21.2873C3.92058 22.1135 4.56882 22.7156 5.34507 22.8858L16.2667 4.36383L15.9368 2.9093Z",
    fill: "#03D18E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9694 4.36383C17.9885 4.36383 11.5881 4.36383 10.661 4.36383C6.71506 9.68902 7.80092 21.4546 14.3996 24H15.9998L17.5432 20.5657L21.0907 18.9091V6.48502C21.0906 5.31361 20.1409 4.36383 18.9694 4.36383Z",
    fill: "#EEF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6611 4.36383H7.21201C6.0406 4.36383 5.09082 5.31366 5.09082 6.48502V21.8788C5.09082 23.0434 6.03409 24 7.21201 24H14.3995C10.3666 18.5804 8.78659 10.6173 10.6611 4.36383Z",
    fill: "#D9E6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0906 18.9091L18.9088 21.0909L15.9998 24V20.9333C15.9998 19.8153 16.9059 18.9091 18.024 18.9091H21.0906Z",
    fill: "#E6E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.909 11.2729C19.1098 11.2729 19.2727 11.1101 19.2727 10.9092C19.2727 10.7083 19.1099 10.5456 18.909 10.5456H9.88295C9.62111 10.7866 9.59617 11.0291 9.91253 11.2729H18.909Z",
    fill: "#8E9BC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.96777 10.8152C6.96777 11.016 7.13057 11.1789 7.33143 11.1789H9.97119C9.95746 10.9352 9.94752 10.6927 9.94162 10.4516H7.33143C7.13057 10.4516 6.96777 10.6144 6.96777 10.8152Z",
    fill: "#6D799E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9089 13.4547C19.1098 13.4547 19.2726 13.2919 19.2726 13.091C19.2726 12.8902 19.1098 12.7274 18.9089 12.7274H10.0402C9.78628 12.9495 9.79312 13.1902 10.1377 13.4546L18.9089 13.4547Z",
    fill: "#8E9BC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.90918 13.091C6.90918 13.2919 7.07198 13.4547 7.27284 13.4547H10.1378C10.1015 13.2114 10.0689 12.969 10.0403 12.7274H7.27288C7.07198 12.7274 6.90918 12.8902 6.90918 13.091Z",
    fill: "#6D799E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.909 15.6364C19.1099 15.6364 19.2727 15.4736 19.2727 15.2728C19.2727 15.072 19.1099 14.9092 18.909 14.9092H10.3999C10.2219 15.1883 10.2548 15.4343 10.5645 15.6364H18.909Z",
    fill: "#8E9BC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.90918 15.2728C6.90918 15.4737 7.07198 15.6364 7.27284 15.6364H10.5646C10.5059 15.3936 10.4511 15.1511 10.4 14.9092H7.27288C7.07198 14.9092 6.90918 15.072 6.90918 15.2728Z",
    fill: "#6D799E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0909 17.8182C13.2917 17.8182 13.4546 17.6554 13.4546 17.4546C13.4546 17.2537 13.2918 17.0909 13.0909 17.0909H10.9623C10.6644 17.3781 10.7257 17.6224 11.1976 17.8182H13.0909Z",
    fill: "#8E9BC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.90918 17.4546C6.90918 17.6555 7.07198 17.8183 7.27284 17.8183H11.1977C11.116 17.5784 11.0375 17.336 10.9624 17.091H7.27284C7.07198 17.091 6.90918 17.2538 6.90918 17.4546Z",
    fill: "#6D799E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.3382,
    cy: 19.7478,
    rx: 4.27597,
    ry: 4.27594,
    fill: "#FA955D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3381 17.9833V21.8536",
    stroke: "#E8F4F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4031 19.9185H19.2734",
    stroke: "#E8F4F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_187_15613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContratGroupe);
export default __webpack_public_path__ + "static/media/contratGroupe.60ba81bf633fa46ce65ad1ce1efacdce.svg";
export { ForwardRef as ReactComponent };